import { render, staticRenderFns } from "./explained.vue?vue&type=template&id=8a8286c6&scoped=true&"
import script from "./explained.vue?vue&type=script&lang=ts&"
export * from "./explained.vue?vue&type=script&lang=ts&"
import style0 from "./explained.vue?vue&type=style&index=0&id=8a8286c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8286c6",
  null
  
)

export default component.exports